<template>
  <vs-select v-model="templateId">
    <vs-select-item
      :key="index"
      :value="item.id"
      :text="item.name"
      v-for="(item, index) in emailTemplates"
    />
  </vs-select>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["condition", "automationId"],
  data() {
    return {
      templateId: "",
    };
  },
  methods: {
    render() {
      return {
        templateId: this.templateId,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      emailTemplates: "emailTemplates/emailTemplates",
    }),
  },
  async mounted() {
    await this.$store.dispatch("emailTemplates/getAll", false);
    if (this.condition) {
      this.templateId = this.condition.templateId;
    }
  },
};
</script>

<style lang="scss">
</style>